import React, { useEffect } from "react"

import { BrowserRouter, Routes } from "react-router-dom"

import { Content } from "./content"
import Spinner from "react-bootstrap/Spinner"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { AuthProvider } from "./context/userContext"
import SessionTimeout from "./components/SessionTimeout"
import DevToolsProtection from "./components/DevToolsProtection"
import PWAPrompt from 'react-ios-pwa-prompt'
import PwaInstallPrompt from "./components/PwaInstallPrompt"
import "./index.css"

function App() {
  useEffect(() => {
    // On mount, set dark mode based on localStorage or default to dark
    const theme = localStorage.getItem('theme')
    if (theme === 'dark' || !theme) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastContainer className="z-[9999999]" style={{ zIndex: 9999999 }} />
        <PWAPrompt
          copyTitle="Add FarmerKonnect to Home Screen"
          copyBody="Install FarmerKonnect for fullscreen access. On iPhone, tap Share, then Add to Home Screen."
          copyClosePrompt="Close"
          permanentlyHideOnDismiss={false}
        />
        <PwaInstallPrompt />

        <Content />

        <SessionTimeout />
        {/* <DevToolsProtection /> */}
      </AuthProvider>

    </BrowserRouter>

  )
}

export default App
